import React, { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import IOSInstallInstructions from './IOSInstallInstructions';

/**
 * Post-tip install banner — slides up from bottom after a successful tip.
 * Only renders when: not installed, not dismissed, tip was successful.
 */
export default function PWAInstallBanner({ show }) {
  const { canInstall, ios, shouldShow, triggerInstall, dismiss } = usePWAInstall();
  const [showIOS, setShowIOS] = useState(false);
  const [hidden, setHidden] = useState(false);

  if (!show || !shouldShow || hidden) return null;

  const handleInstall = async () => {
    if (ios) {
      setShowIOS(true);
    } else if (canInstall) {
      const accepted = await triggerInstall();
      if (accepted) setHidden(true);
    }
  };

  const handleDismiss = () => {
    dismiss();
    setHidden(true);
  };

  if (showIOS) {
    return <IOSInstallInstructions onDismiss={() => { setShowIOS(false); handleDismiss(); }} />;
  }

  // Don't show on Android if browser doesn't support install
  if (!ios && !canInstall) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{ animation: 'slideUp 0.3s ease-out' }}
      data-testid="pwa-install-banner"
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <div className="max-w-md mx-auto px-4 pb-4">
        <div className="rounded-xl p-4 flex items-center gap-3"
          style={{ backgroundColor: '#1a1a1a', border: '1px solid #333', boxShadow: '0 -4px 24px rgba(0,0,0,0.4)' }}>
          <div className="flex-1">
            <p className="text-sm font-medium" style={{ color: '#e8e3db' }}>
              Like TipMe? Add it to your home screen
            </p>
          </div>
          <button onClick={handleInstall}
            className="text-sm font-semibold px-4 py-2 rounded-lg whitespace-nowrap"
            style={{ backgroundColor: '#f0b90b', color: '#1a1a1a' }}
            data-testid="pwa-install-btn">
            Install App
          </button>
          <button onClick={handleDismiss}
            className="text-sm px-2 py-2 rounded-lg whitespace-nowrap"
            style={{ color: '#666' }}
            data-testid="pwa-dismiss-btn">
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
